// import React from "react";
import { store } from "./store";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { logToServer, overrideConsoleMethods } from "./util/logger";

overrideConsoleMethods();

window.onerror = (a, b, c, d, e) => {
  logToServer(`message: ${a}\n    source: ${b}\n    lineno: ${c}\n    colno: ${d}\n    ${e}`, 'error')
  return false;
};

window.addEventListener('error', function (e) {
  //It Will handle JS errors 
})

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
  {/* <React.StrictMode> */}
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Provider store={store}>
        <App />
      </Provider>
    </LocalizationProvider>
  {/* </React.StrictMode> */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
